import React from 'react';

import { Course } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { Box } from '@mui/material';

import { borderRadius, palette, spaces } from '../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../utils/getMuiIcon';
import useScreenSize from '../../../../utils/useScreenSize';

const CourseRegistrationStatus: React.FC<{
  registrationStatus: Course['registrationStatus'];
}> = ({ registrationStatus }) => {
  const { isXsScreen } = useScreenSize();

  const sizeDependantSx = isXsScreen 
    ? { bottom: spaces.xs, right: spaces.xs } 
    : { bottom: spaces.md, right: spaces.md };

  const isInProgress  = registrationStatus === 'progress';

  return registrationStatus !== 'none' ?  (
    <Box
      data-testid='course-registration-status'
      sx={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 24,
        width: 24,
        borderRadius: borderRadius.full,
        backgroundColor: isInProgress ? palette.info.main : palette.success.main,
        color: palette.common.white,
        ...sizeDependantSx
      }}
    >
      <Box
        component={isInProgress ? getMuiIcon('pause') : getMuiIcon('check')}
        sx={{ width: 16, height: 16 }}
        data-testid={
          isInProgress
            ? 'course-registration-status__icon--paused'
            : 'course-registration-status__icon--completed'
        }
      />
    </Box>
  ) : null;
};

export default CourseRegistrationStatus;
